import { ApplicationRef, Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styles: []
})
export class App {
  private readonly router = inject(Router);
  private readonly appRef = inject(ApplicationRef);

  constructor() {
    // Zoneless safety net: after an idle period the app drains to fully stable,
    // and a navigation that resolves across an async boundary (e.g. a lazily
    // loaded route chunk) can activate without scheduling a change-detection
    // tick — the URL/route changes but the RouterOutlet never repaints until a
    // manual refresh. Forcing a tick on NavigationEnd guarantees the activated
    // view renders. Deferred to a microtask so we never call tick() recursively
    // inside an in-progress change-detection pass (e.g. a fully synchronous
    // navigation triggered from a click).
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => queueMicrotask(() => this.appRef.tick()));
  }
}
